<template>
    <span class="tier">
      {{ tierLabel }}: {{ tierLabel == 'Benefit Tier' ? (result.tier == 1 ? 'Select' : 'Standard') : result.tier }} – 
    </span>
</template>

<script setup>

    const props = defineProps({
        result: Object,
        tierLabel: String
    })

</script>

<style lang="scss" scoped>
  span.tier {
    display: inline;
  }
</style>